import React, { useEffect, useState, useCallback } from 'react';
import { Box, Alert, AlertTitle, LinearProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAtomValue } from 'jotai';
import { toastsAtom, Toast } from '../../store/jotai/atoms/toast.atom';
import { regionStore } from '../../store/jotai/store';
import { removeToast } from '../../services/toast-service';

const TOAST_DURATION = 5000;

const ToastItem: React.FC<{ toast: Toast }> = ({ toast }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const remaining = Math.max(0, 100 - (elapsed / TOAST_DURATION) * 100);
      setProgress(remaining);
      if (remaining <= 0) {
        clearInterval(interval);
        removeToast(toast.id);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [toast.id]);

  return (
    <Alert
      severity={toast.severity}
      onClick={() => removeToast(toast.id)}
      action={
        <IconButton
          size='small'
          color='inherit'
          onClick={(e) => {
            e.stopPropagation();
            removeToast(toast.id);
          }}>
          <CloseIcon fontSize='small' />
        </IconButton>
      }
      sx={{
        cursor: 'pointer',
        mb: 1,
        minWidth: 300,
        maxWidth: 400,
        boxShadow: 3,
        position: 'relative',
        overflow: 'hidden'
      }}>
      <AlertTitle sx={{ fontWeight: 'bold' }}>{toast.title}</AlertTitle>
      {toast.message}
      <LinearProgress
        variant='determinate'
        value={progress}
        color='inherit'
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 3,
          opacity: 0.4
        }}
      />
    </Alert>
  );
};

const ToastContainer: React.FC = () => {
  const toasts = useAtomValue(toastsAtom, { store: regionStore });

  if (toasts.length === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 999999999
      }}>
      {[...toasts].reverse().map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </Box>
  );
};

export { ToastContainer };
